"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventType = exports.VERSION = exports.TOPIC_MAPPING = exports.Topic = void 0;
const t = __importStar(require("io-ts"));
const toggle_1 = require("./app/toggle");
const refresh_1 = require("./app/refresh");
const switch_url_1 = require("./app/switch.url");
const knowledge_view_1 = require("./app/knowledge.view");
const section_view_1 = require("./app/section.view");
const toast_close_1 = require("./app/toast.close");
const toast_close_all_1 = require("./app/toast.close.all");
const toast_receive_1 = require("./app/toast.receive");
const login_success_1 = require("./app/login.success");
const login_failure_1 = require("./app/login.failure");
const logout_1 = require("./app/logout");
const bug_tracking_1 = require("./app/bug.tracking");
const login_failure_2 = require("./auth/login.failure");
const login_success_2 = require("./auth/login.success");
const provisioning_success_1 = require("./auth/provisioning.success");
const archive_1 = require("./content/archive");
const create_1 = require("./content/create");
const favorite_add_1 = require("./content/favorite.add");
const favorite_remove_1 = require("./content/favorite.remove");
const feedback_1 = require("./content/feedback");
const read_1 = require("./content/read");
const satisfaction_1 = require("./content/satisfaction");
const search_1 = require("./content/search");
const search_abort_1 = require("./content/search.abort");
const search_success_1 = require("./content/search.success");
const recommendation_success_1 = require("./content/recommendation.success");
const recommendation_abort_1 = require("./content/recommendation.abort");
const recommendation_receive_1 = require("./content/recommendation.receive");
const copy_1 = require("./content/copy");
const meta_view_1 = require("./content/meta.view");
const verificationPolicy_1 = require("./content/verificationPolicy");
const contribution_1 = require("./general/contribution");
const feedback_2 = require("./general/feedback");
const notification_1 = require("./general/notification");
const integration_add_1 = require("./company/integration.add");
const integration_remove_1 = require("./company/integration.remove");
const read_2 = require("./product/read");
const invitation_register_1 = require("./user/invitation.register");
const invitation_delete_1 = require("./user/invitation.delete");
const invitation_1 = require("./user/invitation");
const invitation_renew_1 = require("./user/invitation.renew");
const content_1 = require("./ticket/content");
const update_1 = require("./task/update");
const reaction_1 = require("./task/reaction");
const status_1 = require("./task/status");
const read_3 = require("./notification/read");
const read_all_1 = require("./notification/read.all");
const comment_1 = require("./notification/comment");
const receive_1 = require("./notification/receive");
const hub_card_view_1 = require("./task/hub.card.view");
const comment_2 = require("./feedback/comment");
const content_read_1 = require("./public/content.read");
const case_read_1 = require("./public/case.read");
const content_satisfaction_1 = require("./public/content.satisfaction");
const content_feedback_1 = require("./public/content.feedback");
const content_search_1 = require("./public/content.search");
const content_search_success_1 = require("./public/content.search.success");
const content_search_abort_1 = require("./public/content.search.abort");
const knowledge_read_1 = require("./public/knowledge.read");
const content_get_success_1 = require("./public/api/content.get.success");
const search_success_2 = require("./public/api/search.success");
const search_failure_1 = require("./public/api/search.failure");
const message_create_1 = require("./thread/message.create");
const message_edit_1 = require("./thread/message.edit");
const message_delete_1 = require("./thread/message.delete");
const message_vote_1 = require("./thread/message.vote");
const status_2 = require("./thread/status");
const shortcut_1 = require("./slack/shortcut");
const modal_action_1 = require("./slack/modal.action");
const preference_add_1 = require("./settings/preference.add");
const preference_remove_1 = require("./settings/preference.remove");
const language_1 = require("./settings/language");
const public_add_1 = require("./settings/public.add");
const public_update_1 = require("./settings/public.update");
const public_remove_1 = require("./settings/public.remove");
const public_deployment_start_1 = require("./settings/public.deployment.start");
const question_1 = require("./ask/question");
const answer_1 = require("./ask/answer");
const error_1 = require("./ask/error");
const useSource_1 = require("./ask/useSource");
const public_login_success_1 = require("./auth/public.login.success");
const published_update_1 = require("./content/published.update");
const isOutdated_update_1 = require("./content/isOutdated.update");
const alerts_1 = require("./obsolescence/alerts");
const feedback_3 = require("./ask/feedback");
const copyAnswer_1 = require("./ask/copyAnswer");
var Topic;
(function (Topic) {
    Topic["APP_TOGGLE"] = "app.toggle";
    Topic["APP_REFRESH"] = "app.refresh";
    Topic["APP_SWITCH_URL"] = "app.switch.url";
    Topic["APP_SECTION_VIEW"] = "app.section.view";
    Topic["APP_KNOWLEDGE_VIEW"] = "app.knowledge.view";
    Topic["APP_TOAST_CLOSE"] = "app.toast.close";
    Topic["APP_TOAST_CLOSE_ALL"] = "app.toast.close.all";
    Topic["APP_TOAST_RECEIVE"] = "app.toast.receive";
    Topic["APP_LOGIN_SUCCESS"] = "app.login.success";
    Topic["APP_LOGIN_FAILURE"] = "app.login.failure";
    Topic["APP_LOGOUT"] = "app.logout";
    Topic["APP_BUG_TRACKING"] = "app.bug.tracking";
    Topic["AUTH_LOGIN_FAILURE"] = "auth.login.failure";
    Topic["AUTH_LOGIN_SUCCESS"] = "auth.login.success";
    Topic["AUTH_PROVISIONING_SUCCESS"] = "auth.provisioning.success";
    Topic["AUTH_PUBLIC_LOGIN_SUCCESS"] = "auth.public.login.success";
    Topic["CONTENT_ARCHIVE"] = "content.archive";
    Topic["CONTENT_CREATE"] = "content.create";
    Topic["CONTENT_FAVORITE_ADD"] = "content.favorite.add";
    Topic["CONTENT_FAVORITE_REMOVE"] = "content.favorite.remove";
    Topic["CONTENT_FEEDBACK"] = "content.feedback";
    Topic["CONTENT_READ"] = "content.read";
    Topic["CONTENT_SATISFACTION"] = "content.satisfaction";
    Topic["CONTENT_SEARCH_ABORT"] = "content.search.abort";
    Topic["CONTENT_SEARCH_SUCCESS"] = "content.search.success";
    Topic["CONTENT_SEARCH"] = "content.search";
    Topic["CONTENT_RECOMMENDATION_SUCCESS"] = "content.recommendation.success";
    Topic["CONTENT_RECOMMENDATION_ABORT"] = "content.recommendation.abort";
    Topic["CONTENT_RECOMMENDATION_RECEIVE"] = "content.recommendation.receive";
    Topic["CONTENT_COPY"] = "content.copy";
    Topic["CONTENT_META_VIEW"] = "content.meta.view";
    Topic["CONTENT_VERIFICATION_POLICY_ADD"] = "content.verificationPolicy.add";
    Topic["CONTENT_VERIFICATION_POLICY_REMOVE"] = "content.verificationPolicy.remove";
    Topic["CONTENT_VERIFICATION_POLICY_UPDATE"] = "content.verificationPolicy.update";
    Topic["CONTENT_PUBLISHED_UPDATE"] = "content.published.update";
    Topic["CONTENT_IS_OUTDATED_UPDATE"] = "content.isOutdated.update";
    Topic["GENERAL_CONTRIBUTION"] = "general.contribution";
    Topic["GENERAL_FEEDBACK"] = "general.feedback";
    Topic["GENERAL_NOTIFICATION"] = "general.notification";
    Topic["COMPANY_INTEGRATION_ADD"] = "company.integration.add";
    Topic["COMPANY_INTEGRATION_REMOVE"] = "company.integration.remove";
    Topic["PRODUCT_READ"] = "product.read";
    Topic["USER_INVITATION_REGISTER"] = "user.register";
    Topic["USER_DELETE"] = "user.delete";
    Topic["USER_INVITATION"] = "user.invitation";
    Topic["USER_INVITATION_RENEW"] = "user.invitation.renew";
    Topic["TICKET_CONTENT"] = "ticket.content";
    Topic["TASK_UPDATE"] = "task.update";
    Topic["TASK_REACTION"] = "task.reaction";
    Topic["TASK_STATUS"] = "task.status";
    Topic["NOTIFICATION_READ"] = "notification.read";
    Topic["NOTIFICATION_READ_ALL"] = "notification.read.all";
    Topic["NOTIFICATION_COMMENT"] = "notification.comment";
    Topic["NOTIFICATION_RECEIVE"] = "notification.receive";
    Topic["HUB_CARD_VIEW"] = "hub.card.view";
    Topic["FEEDBACK_COMMENT"] = "feedback.comment";
    Topic["PUBLIC_CONTENT_READ"] = "public.content.read";
    Topic["PUBLIC_CASE_READ"] = "public.case.read";
    Topic["PUBLIC_CONTENT_SATISFACTION"] = "public.content.satisfaction";
    Topic["PUBLIC_CONTENT_FEEDBACK"] = "public.content.feedback";
    Topic["PUBLIC_CONTENT_SEARCH"] = "public.content.search";
    Topic["PUBLIC_CONTENT_SEARCH_SUCCESS"] = "public.content.search.success";
    Topic["PUBLIC_CONTENT_SEARCH_ABORT"] = "public.content.search.abort";
    Topic["PUBLIC_KNOWLEDGE_READ"] = "public.knowledge.read";
    Topic["PUBLIC_API_CONTENT_GET_SUCCESS"] = "public.content.get.success";
    Topic["PUBLIC_API_SEARCH_SUCCESS"] = "public.api.search.success";
    Topic["PUBLIC_API_SEARCH_FAILURE"] = "public.api.search.failure";
    Topic["THREAD_MESSAGE_CREATE"] = "thread.message.create";
    Topic["THREAD_MESSAGE_EDIT"] = "thread.message.edit";
    Topic["THREAD_MESSAGE_DELETE"] = "thread.message.delete";
    Topic["THREAD_MESSAGE_VOTE"] = "thread.message.vote";
    Topic["THREAD_STATUS"] = "thread.status";
    Topic["SLACK_SHORTCUT"] = "slack.shortcut";
    Topic["SLACK_MODAL_ACTION"] = "slack.modal.action";
    Topic["SETTINGS_ADD"] = "settings.add";
    Topic["SETTINGS_REMOVE"] = "settings.remove";
    Topic["SETTINGS_LANGUAGE"] = "settings.language";
    Topic["PUBLIC_SETTINGS_ADD"] = "public.settings.add";
    Topic["PUBLIC_SETTINGS_UPDATE"] = "public.settings.update";
    Topic["PUBLIC_SETTINGS_REMOVE"] = "public.settings.remove";
    Topic["PUBLIC_SETTINGS_DEPLOYMENT_START"] = "public.settings.deployment.start";
    Topic["ASK_QUESTION"] = "ask.question";
    Topic["ASK_ANSWER"] = "ask.answer";
    Topic["ASK_ERROR"] = "ask.error";
    Topic["ASK_USE_SOURCE"] = "ask.use.source";
    Topic["ASK_FEEDBACK"] = "ask.feedback";
    Topic["OBSOLESCENCE_ALERTS"] = "obsolescence.alerts";
    Topic["ASK_COPY_ANSWER"] = "ask.copy.answer";
})(Topic = exports.Topic || (exports.Topic = {}));
exports.TOPIC_MAPPING = {
    [Topic.APP_TOGGLE]: toggle_1.AppToggleEventType,
    [Topic.APP_REFRESH]: refresh_1.AppRefreshEventType,
    [Topic.APP_SWITCH_URL]: switch_url_1.AppSwitchUrlEventType,
    [Topic.APP_SECTION_VIEW]: section_view_1.AppSectionViewEventType,
    [Topic.APP_KNOWLEDGE_VIEW]: knowledge_view_1.AppKnowledgeViewEventType,
    [Topic.APP_TOAST_CLOSE]: toast_close_1.AppToastCloseEventType,
    [Topic.APP_TOAST_CLOSE_ALL]: toast_close_all_1.AppToastCloseAllEventType,
    [Topic.APP_TOAST_RECEIVE]: toast_receive_1.AppToastReceiveEventType,
    [Topic.APP_LOGIN_SUCCESS]: login_success_1.AppLoginSuccessEventType,
    [Topic.APP_LOGIN_FAILURE]: login_failure_1.AppLoginFailureEventType,
    [Topic.APP_LOGOUT]: logout_1.AppLogoutEventType,
    [Topic.APP_BUG_TRACKING]: bug_tracking_1.AppBugTrackingEventType,
    [Topic.AUTH_LOGIN_FAILURE]: login_failure_2.AuthLoginFailureEventType,
    [Topic.AUTH_LOGIN_SUCCESS]: login_success_2.AuthLoginSuccessEventType,
    [Topic.AUTH_PROVISIONING_SUCCESS]: provisioning_success_1.AuthProvisioningSuccessEventType,
    [Topic.AUTH_PUBLIC_LOGIN_SUCCESS]: public_login_success_1.AuthPublicLoginSuccessEventType,
    [Topic.CONTENT_ARCHIVE]: archive_1.ContentArchiveEventType,
    [Topic.CONTENT_CREATE]: create_1.ContentCreateEventType,
    [Topic.CONTENT_FAVORITE_ADD]: favorite_add_1.ContentFavoriteAddEventType,
    [Topic.CONTENT_FAVORITE_REMOVE]: favorite_remove_1.ContentFavoriteRemoveEventType,
    [Topic.CONTENT_FEEDBACK]: feedback_1.ContentFeedbackEventType,
    [Topic.CONTENT_READ]: read_1.ContentReadEventType,
    [Topic.CONTENT_SATISFACTION]: satisfaction_1.ContentSatisfactionEventType,
    [Topic.CONTENT_SEARCH_ABORT]: search_abort_1.ContentSearchAbortEventType,
    [Topic.CONTENT_SEARCH_SUCCESS]: search_success_1.ContentSearchSuccessEventType,
    [Topic.CONTENT_RECOMMENDATION_SUCCESS]: recommendation_success_1.ContentRecommendationSuccessEventType,
    [Topic.CONTENT_RECOMMENDATION_ABORT]: recommendation_abort_1.ContentRecommendationAbortEventType,
    [Topic.CONTENT_RECOMMENDATION_RECEIVE]: recommendation_receive_1.ContentRecommendationReceiveEventType,
    [Topic.CONTENT_SEARCH]: search_1.ContentSearchEventType,
    [Topic.CONTENT_COPY]: copy_1.ContentCopyEventType,
    [Topic.CONTENT_META_VIEW]: meta_view_1.ContentMetaViewEventType,
    [Topic.CONTENT_VERIFICATION_POLICY_ADD]: verificationPolicy_1.ContentVerificationPolicyAddEventType,
    [Topic.CONTENT_VERIFICATION_POLICY_REMOVE]: verificationPolicy_1.ContentVerificationPolicyRemoveEventType,
    [Topic.CONTENT_VERIFICATION_POLICY_UPDATE]: verificationPolicy_1.ContentVerificationPolicyUpdateEventType,
    [Topic.CONTENT_PUBLISHED_UPDATE]: published_update_1.ContentPublishedEventType,
    [Topic.CONTENT_IS_OUTDATED_UPDATE]: isOutdated_update_1.ContentIsOutdatedEventType,
    [Topic.GENERAL_CONTRIBUTION]: contribution_1.GeneralContributionEventType,
    [Topic.GENERAL_FEEDBACK]: feedback_2.GeneralFeedbackEventType,
    [Topic.GENERAL_NOTIFICATION]: notification_1.GeneralNotificationEventType,
    [Topic.COMPANY_INTEGRATION_ADD]: integration_add_1.CompanyIntegrationAddEventType,
    [Topic.COMPANY_INTEGRATION_REMOVE]: integration_remove_1.CompanyIntegrationRemoveEventType,
    [Topic.PRODUCT_READ]: read_2.ProductReadEventType,
    [Topic.USER_INVITATION_REGISTER]: invitation_register_1.UserRegisterEventType,
    [Topic.USER_DELETE]: invitation_delete_1.UserDeleteEventType,
    [Topic.USER_INVITATION]: invitation_1.UserInvitationEventType,
    [Topic.USER_INVITATION_RENEW]: invitation_renew_1.UserInvitationRenewEventType,
    [Topic.TICKET_CONTENT]: content_1.TicketContentEventType,
    [Topic.TASK_UPDATE]: update_1.TaskUpdateEventType,
    [Topic.TASK_REACTION]: reaction_1.TaskReactionEventType,
    [Topic.TASK_STATUS]: status_1.TaskStatusEventType,
    [Topic.NOTIFICATION_READ]: read_3.NotificationReadEventType,
    [Topic.NOTIFICATION_READ_ALL]: read_all_1.NotificationReadAllEventType,
    [Topic.NOTIFICATION_COMMENT]: comment_1.NotificationCommentEventType,
    [Topic.NOTIFICATION_RECEIVE]: receive_1.NotificationReceiveEventType,
    [Topic.HUB_CARD_VIEW]: hub_card_view_1.HubCardViewEventType,
    [Topic.FEEDBACK_COMMENT]: comment_2.FeedbackCommentEventType,
    [Topic.PUBLIC_CONTENT_READ]: content_read_1.PublicContentReadEventType,
    [Topic.PUBLIC_CASE_READ]: case_read_1.PublicCaseReadEventType,
    [Topic.PUBLIC_CONTENT_SATISFACTION]: content_satisfaction_1.PublicContentSatisfactionEventType,
    [Topic.PUBLIC_CONTENT_FEEDBACK]: content_feedback_1.PublicContentFeedbackEventType,
    [Topic.PUBLIC_CONTENT_SEARCH]: content_search_1.PublicContentSearchEventType,
    [Topic.PUBLIC_CONTENT_SEARCH_SUCCESS]: content_search_success_1.PublicContentSearchSuccessEventType,
    [Topic.PUBLIC_CONTENT_SEARCH_ABORT]: content_search_abort_1.PublicContentSearchAbortEventType,
    [Topic.PUBLIC_KNOWLEDGE_READ]: knowledge_read_1.PublicKnowledgeReadType,
    [Topic.PUBLIC_API_CONTENT_GET_SUCCESS]: content_get_success_1.PublicApiContenGetSuccessEventType,
    [Topic.PUBLIC_API_SEARCH_SUCCESS]: search_success_2.PublicApiSearchSuccessEventType,
    [Topic.PUBLIC_API_SEARCH_FAILURE]: search_failure_1.PublicApiSearchFailureEventType,
    [Topic.THREAD_MESSAGE_CREATE]: message_create_1.ThreadMessageCreateEventType,
    [Topic.THREAD_MESSAGE_EDIT]: message_edit_1.ThreadMessageEditEventType,
    [Topic.THREAD_MESSAGE_DELETE]: message_delete_1.ThreadMessageDeleteEventType,
    [Topic.THREAD_MESSAGE_VOTE]: message_vote_1.ThreadMessageVoteEventType,
    [Topic.THREAD_STATUS]: status_2.ThreadStatusEventType,
    [Topic.SLACK_SHORTCUT]: shortcut_1.SlackShortcutEventType,
    [Topic.SLACK_MODAL_ACTION]: modal_action_1.SlackModalActionEventType,
    [Topic.SETTINGS_ADD]: preference_add_1.SettingsPreferenceAddEventType,
    [Topic.SETTINGS_REMOVE]: preference_remove_1.SettingsPreferenceRemoveEventType,
    [Topic.SETTINGS_LANGUAGE]: language_1.SettingsLanguageEventType,
    [Topic.PUBLIC_SETTINGS_ADD]: public_add_1.PublicSettingsAddEventType,
    [Topic.PUBLIC_SETTINGS_UPDATE]: public_update_1.PublicSettingsUpdateEventType,
    [Topic.PUBLIC_SETTINGS_REMOVE]: public_remove_1.PublicSettingsRemoveEventType,
    [Topic.PUBLIC_SETTINGS_DEPLOYMENT_START]: public_deployment_start_1.PublicSettingsDeploymentStartEventType,
    [Topic.ASK_QUESTION]: question_1.AskQuestionEventType,
    [Topic.ASK_ANSWER]: answer_1.AskAnswerEventType,
    [Topic.ASK_USE_SOURCE]: useSource_1.AskUseSourceEventType,
    [Topic.ASK_COPY_ANSWER]: copyAnswer_1.AskCopyAnswerEventType,
    [Topic.ASK_FEEDBACK]: feedback_3.AskFeedbackEventType,
    [Topic.ASK_ERROR]: error_1.AskErrorEventType,
    [Topic.OBSOLESCENCE_ALERTS]: alerts_1.ObsolescenceAlertsEventType,
};
exports.VERSION = "0.1.78";
const createEventType = (T) => t.intersection([
    t.type({
        origin: t.string,
        topic: t.string,
        event: T,
    }),
    t.partial({ url: t.string }),
]);
exports.createEventType = createEventType;
